var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app", attrs: { id: "app" } },
    [
      !_vm.loaded
        ? _c("div", { staticClass: "main-loading" }, [
            _c(
              "svg",
              {
                staticClass: "main-loading__image",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 208.91 200.02"
                }
              },
              [
                _c("title", [_vm._v("Upmood_Logo_v15")]),
                _c("g", { attrs: { id: "Layer_2", "data-name": "Layer 2" } }, [
                  _c("path", {
                    attrs: {
                      fill: "#3dbfcd",
                      d:
                        "M63.23,64.64A63.22,63.22,0,0,0,22,175.78L43.62,200V188A63.23,63.23,0,1,0,63.23,64.64Zm0,104.6a41.37,41.37,0,1,1,41.37-41.37A41.37,41.37,0,0,1,63.23,169.24Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      fill: "#3dbfcd",
                      d:
                        "M75.94,125.92H63.82a6.07,6.07,0,0,0-6.14,5.63,12.21,12.21,0,1,0,24.4,0A6.08,6.08,0,0,0,75.94,125.92Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      fill: "#3dbfcd",
                      d:
                        "M50,125.3c8.83,0,8.84-13.73,0-13.73s-8.85,13.73,0,13.73Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      fill: "#3dbfcd",
                      d:
                        "M89.79,125.3c8.83,0,8.85-13.73,0-13.73s-8.85,13.73,0,13.73Z"
                    }
                  }),
                  _c("circle", {
                    attrs: {
                      fill: "#3dbfcd",
                      cx: "104.6",
                      cy: "95.63",
                      r: "10.92"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      fill: "#f0cb2a",
                      d:
                        "M208.91,63.23a63.24,63.24,0,1,0-43.62,60.11v12.15l22.13-24.79A63,63,0,0,0,208.91,63.23Zm-104.6,0a41.37,41.37,0,1,1,41.37,41.37A41.37,41.37,0,0,1,104.31,63.23Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      fill: "#f0cb2a",
                      d:
                        "M145.09,70.44H133a6.07,6.07,0,0,0-6.14,5.63,12.21,12.21,0,1,0,24.4,0A6.06,6.06,0,0,0,145.09,70.44Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      fill: "#f0cb2a",
                      d:
                        "M158.94,69.81c-8.83,0-8.84-13.72,0-13.72s8.85,13.72,0,13.72Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      fill: "#f0cb2a",
                      d:
                        "M119.12,69.81c-8.83,0-8.85-13.72,0-13.72s8.85,13.72,0,13.72Z"
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "main-loading__text" }, [_vm._v("Loading")])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "router-anim" } },
        [
          _c(
            "keep-alive",
            [
              _c("router-view", {
                staticClass: "main-router",
                class: { "overflow-hidden": _vm.$route.name === "verify" },
                on: {
                  mounted: function($event) {
                    _vm.loaded = true
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("AppNotificationBanner", {
        attrs: { visible: _vm.notificationStatus }
      }),
      _vm._v(" "),
      _c("AppModal", { attrs: { visible: _vm.modalStatus } }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _c("h2", [_vm._v("Too many request!")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "You can try again later after a minute. If you're logged in, your account will automatically logged out after this."
              )
            ]),
            _vm._v(" "),
            _c(
              "AppButton",
              {
                staticClass: "button",
                attrs: { modifier: "small-primary", disabled: false },
                on: {
                  click: function($event) {
                    return _vm.confirm()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("ok")) + "\n                ")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 